import React, { useEffect } from 'react';

export default function AuthCompletePage() {
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const t = p.get('token');
    if (t) localStorage.setItem('clairifi_token', t);
    const token = t || localStorage.getItem('clairifi_token') || '';

    const go = async () => {
      try {
        if (localStorage.getItem('clairifi_terms_accepted') === '1') {
          await fetch('/api/auth/accept-terms', {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` }
          });
        }
      } catch { /* ignore */ }

      // Early access: skip plan selection entirely and go straight to the app
      try {
        // Still ping /api/auth/me to warm session, but ignore subscription state
        await fetch('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } });
      } catch { /* ignore */ }
      window.location.replace('/dashboard');

    };

    go();
  }, []);

  return <div style={{padding:24, color:'#9ca3af'}}>Finishing sign-in…</div>;
}
